import { apiClient } from './apiClient'

export interface FavoriteIdentity {
  userId?: number | null
  externalPlayerId?: string | null
}

export const favoriteService = {
  async getFavorites(): Promise<{ userIds: number[]; externalPlayerIds: string[] }> {
    const response = await apiClient.get<{ userIds: number[]; externalPlayerIds: string[] }>('/favorites')
    return response.data
  },

  async addFavorite(target: FavoriteIdentity): Promise<void> {
    await apiClient.post('/favorites', target)
  },

  async removeFavorite(target: FavoriteIdentity): Promise<void> {
    await apiClient.delete('/favorites', { data: target })
  }
}